import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NavbarComponent } from "./navbar.component";
import { DialogChangePassword } from "./dialog-component/change-password/dialog-change-password.component";
import { DialogProfileComponent } from "./dialog-component/profile/profile.component";
import { FuseSharedModule } from "@fuse/shared.module";
import { DialogEditPrivacyPolicyComponent } from "./dialog-component/privacy/edit-privacy.component";

@NgModule({
    declarations: [
        NavbarComponent,
        DialogChangePassword,
        DialogProfileComponent,
        DialogEditPrivacyPolicyComponent,
    ],
    imports: [
        FuseSharedModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatTooltipModule,
    ],
    exports: [NavbarComponent],
})
export class NavbarModule {}
